import React from 'react'
import PageAnimation from '@shared/components/page-animation'

import { MainPlatform } from '../documents/sections/main-platform'

import { DocumentList } from './sections/document-list'

function View(props): JSX.Element {
	return (
		<PageAnimation>
			<MainPlatform />
			<DocumentList {...props} />
		</PageAnimation>
	)
}

export default View
